import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  templates: [],
  template: {},
  sections: [],
  section: {},
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0
  },
  size: 1,
  loading: false,
  search: ''
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/templates/index.js